<template>
  <div style="cursor: pointer;">
    <div v-for="item in buttonlist" :key="item.id">
      <!-- 白色背景 -->
      <div style="
          display: flex;
          flex-direction: row;
          position: absolute;top:-3.61vh;
          left:1.5625vw;
        " :style="item.leftS" :zIndex="1004">
        <div style="display: flex; flex-direction: column">
          <div :class="[!item.noCheckX ? 'classChance' : 'classNoChance']" class="Obtuse2" :style="item.bwidth">
            {{ item.title }}
          </div>
          <div class="straight2" :class="[!item.noCheckX ? 'classChance' : 'classNoChance']"></div>
        </div>
        <div :class="[!item.noCheckX ? 'triangle2' : 'riangle2No']"></div>
      </div>

      <!-- 绿色背景 -->
      <div v-if="item.noCheckX == true" style="display:flex;flex-direction:row;position:absolute;top:-3.61vh;cursor:pointer;" :style="item.leftX" :zIndex="1005" @click="openTopButtom(item.id)">
        <div style="display: flex; flex-direction: column;">
          <div class="Obtuse" :style="item.lwidth">{{ item.title }}</div>
          <div class="straight"></div>
        </div>
        <div class="triangle"></div>
      </div>
    </div>
  </div>
</template>

<script>
//  备注提示：   累加规律 172 px
//       buttonlist:[
//         {'id':1,'leftS':'left:30px','leftX':'left:28px','title':'地道特产','noCheckX':true,}, bwidth  lwidth
//         {'id':2,'leftS':'left:202px','leftX':'left:200px','title':'纪念品','noCheckX':false,},
//         {'id':3,'leftS':'left:374px','leftX':'left:372px','title':'商家推荐','noCheckX':true,}
//       ],
export default {
  name: "topB",
  props: ["buttonlist"],
  data() {
    return {
      topButtonStyleList: [],
      LWidth: "width:8.59375vw",
      BWidth: "width:8.64583vw",
      className: { zIndex: "9999", background: "red" }
    };
  },
  created() {
    // console.log(this.buttonlist)
    this.buttonlist.forEach((item, index, arr) => {
      this.buttonlist[index].bwidth
        ? ""
        : (this.buttonlist[index].bwidth = this.BWidth);
      this.buttonlist[index].lwidth
        ? ""
        : (this.buttonlist[index].lwidth = this.LWidth);
    });
    // console.log('this.buttonlist:',this.buttonlist)
  },
  methods: {
    openTopButtom(id) {
      this.buttonlist.forEach((item, index, arr) => {
        id == item.id
          ? ((this.buttonlist[index].noCheckX = false),
            this.$emit("changeDataList", id))
          : (this.buttonlist[index].noCheckX = true);
      });
    }
  }
};
</script>

<style scoped>
.classChance {
  z-index: 2000;
}
.classNoChance {
  background: #d9d9d9 !important;
}
.Obtuse {
  font-size: 1.481vh;
  color: #fff;
  background-color: #449088;
  height: 3.7037vh;
  border-radius: 0.5208vw;
  line-height: 3.7037vh;
  border-color: #fff;
  padding-left: 1.5625vw;
}
.straight {
  margin-top: -0.9259vh;
  background-color: #449088;
  height: 0.9259vh;
  border-color: #fff;
}

.triangle {
  z-index: 1009;
  width: 0;
  height: 0;
  margin-left: -0.15625vw;
  border-bottom: 3.5185vh solid #449088;
  margin-top: 0.18518vh;
  border-right: 1.8518vh solid transparent;
}

.Obtuse2 {
  font-size: 1.4814vh;
  color: #d87001;
  background-color: #f3f3f3;
  height: 3.7037vh;
  margin-top: -0.09259vh;
  margin-left: -0.1302vw;
  border-radius: 10px;
  line-height: 3.7037vh;
  border-color: #f3f3f3;
  padding-left: 1.5625vw;
}
.straight2 {
  background-color: #f3f3f3;
  margin-top: -0.9259vh;
  height: 1.01851vh;
  margin-left: -0.1302vw;
  border-color: #f3f3f3;
}

.triangle2 {
  width: 0;
  height: 0;
  margin-left: -0.10416vw;
  border-bottom: 3.518vh solid #f3f3f3;
  margin-top: 0.1851vh;
  border-right: 0.9vw solid transparent;
  z-index: 1009;
}
.riangle2No {
  width: 0;
  height: 0;
  margin-left: -0.10416vw;
  border-bottom: 3.518vh solid #d9d9d9;
  margin-top: 0.1851vh;
  border-right: 0.9vw solid transparent;
  z-index: 1009;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopButtom.vue